module.exports = __webpack_public_path__ + "static/media/fleet-certified-icon-green.b7436b9d.svg";